export interface UserData {}

//

export type PermissionActions = {
  [K in keyof Permissions]: `${K & string}.${Permissions[K]["action"]}`;
}[keyof Permissions];

export type ExtractResourse<T extends string> = T extends `${infer Resourse}.${string}`
  ? Resourse
  : never;

export type ExtractAction<T extends string> = T extends `${string}.${infer Action}`
  ? Action
  : never;

//

export const PERMISSIONS = {
  products: ["view", "create", "update", "archive"],
  kaspiProducts: ["connect", "parse"],
  analytics: ["reduced-view", "full-view"],
  orders: ["view", "create"],
  cabinets: ["view", "connect", "update", "archive"],
  offers: ["unlink"],
} as const satisfies Record<string, string[]>;

//

export const PERMISSION_ACTIONS: PermissionActions[] = Object.entries(PERMISSIONS).flatMap(
  ([resource, actions]) => actions.map((action) => `${resource}.${action}` as PermissionActions),
);

//

export interface PermissionsDataType {
  products: null;
  kaspiProducts: null;
  analytics: null;
  orders: null;
  cabinets: null;
  offers: null;
}

export type Permissions = {
  [K in keyof typeof PERMISSIONS]: {
    dataType: PermissionsDataType[K];
    action: (typeof PERMISSIONS)[K][number];
  };
};

export type Resourses = keyof Permissions;
export type Actions = Permissions[Resourses]["action"];
